var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h2",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentBetSlipState < 1 || _vm.betTypeStakes.A,
            expression: "currentBetSlipState<1 || betTypeStakes.A"
          }
        ],
        staticClass: "header-PARLAY"
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("BetSlip.tab.title.PARLAY")) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.allowedBetTypesPRL.length
      ? _c(
          "div",
          _vm._l(_vm.allowedBetTypesPRL, function(bt) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentBetSlipState < 1 ||
                      _vm.betTypeStakes[bt.IDFOBetType],
                    expression:
                      "currentBetSlipState<1 || betTypeStakes[bt.IDFOBetType]"
                  }
                ]
              },
              [
                _c("bet-type-parlay", {
                  attrs: {
                    bt: bt,
                    stake: _vm.betTypeStakes[bt.IDFOBetType],
                    parlayTeamsNo: _vm.parlayTeamsNo,
                    allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
                    gettingABTnR: _vm.gettingABTnR,
                    currentBetSlipState: _vm.currentBetSlipState
                  }
                })
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentBetSlipState == 0 &&
    _vm.betsNo > 1 &&
    !_vm.allowedBetTypesPRL.length &&
    !_vm.interRelatedLen
      ? _c(
          "div",
          { staticClass: "msg info all_corners NoParlayAvailable" },
          [
            _c("icon", {
              attrs: { name: "icon-information", colorName: "blue" }
            }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("BetSlip.tab.PARLAY.info.notAvailable")) +
                "\n  "
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentBetSlipState == 0 && _vm.betsNo == 1
      ? _c(
          "div",
          { staticClass: "msg info all_corners" },
          [
            _c("icon", {
              attrs: { name: "icon-information", colorName: "blue" }
            }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("BetSlip.tab.PARLAY.info.minSelectionsNo")) +
                "\n  "
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentBetSlipState == 0 && _vm.betsNo > 1 && _vm.interRelatedLen
      ? _c(
          "div",
          { staticClass: "msg info interRelated all_corners" },
          [
            _c("icon", {
              attrs: { name: "icon-information", colorName: "blue" }
            }),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("BetSlip.tab.PARLAY.info.interRelated")) +
                "\n  "
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b3fd958", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3fd958","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/ParlayTab.vue
// module id = null
// module chunks = 